import { render, staticRenderFns } from "./ShopsRemoveShopForm.vue?vue&type=template&id=da68f278&"
import script from "./ShopsRemoveShopForm.vue?vue&type=script&lang=js&"
export * from "./ShopsRemoveShopForm.vue?vue&type=script&lang=js&"
import style0 from "./ShopsRemoveShopForm.vue?vue&type=style&index=0&id=da68f278&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports